module.exports = __webpack_public_path__ + "static/media/alarm.159b8192.svg";